// ::: RSO_CHANGE ::: cas authentication(login/logout) redirection - CAS-300
import * as Util from "../auth/Util";

export function getProtocolType(location, application) {
  const searchParams = new URLSearchParams(location.search);

  if (location.pathname.includes("/cas/") || searchParams.has("service")) {
    return "cas";
  }

  const oAuthParams = Util.getOAuthGetParameters();
  if (oAuthParams?.responseType) {
    return oAuthParams.responseType;
  }

  if (searchParams.has("SAMLRequest")) {
    return "saml";
  }

  return "login";
}
